window.onresize = function () {
  fnResize();
}
window.onload = function () {
  fnResize();
}
setTimeout(()=>{
  fnResize();
},1600)
function fnResize() {
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
  let num = deviceWidth / 10
  document.documentElement.style.fontSize = num + 'px';
}
fnResize()